import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Portfolio.css';
import API_URL from '../../api/ExamCalendarApi';

const Portfolio = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [category, setCategory] = useState('');
  const [imageUrl, setImageUrl] = useState(null);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchPortfolios();
  }, []);

  // Fetch all portfolios
  const fetchPortfolios = async () => {
    try {
      const response = await axios.get(`${API_URL}/portfolio/all`);
      setPortfolios(response.data);
    } catch (error) {
      console.error('Error fetching portfolios:', error);
    }
  };

  // Handle file input change
  const handleFileChange = (e) => {
    setImageUrl(e.target.files[0]);
  };

  // Handle dropdown change
  const handleDropdownChange = (e, setter) => {
    setter(e.target.value);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('category', category);
    if (imageUrl) {
      formData.append('imageUrl', imageUrl);
    }

    try {
      if (editId) {
        // Update portfolio
        await axios.put(`${API_URL}/portfolio/edit/${editId}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        setEditId(null); // Clear edit state
      } else {
        // Add new portfolio
        await axios.post(`${API_URL}/portfolio/add`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }

      // Reset form
      setCategory('');
      setImageUrl(null);
      fetchPortfolios(); // Refresh portfolio list
    } catch (error) {
      console.error('Error submitting portfolio:', error);
    }
  };

  // Handle editing a portfolio
  const handleEdit = (portfolio) => {
    setCategory(portfolio.category);
    setEditId(portfolio._id);
  };

  // Handle deleting a portfolio
  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/portfolio/delete/${id}`);
      fetchPortfolios(); // Refresh the list
    } catch (error) {
      console.error('Error deleting portfolio:', error);
    }
  };

  return (
    <div className="admin-portfolio-container">
      <div className='admin-portfolio-section'>
      <h2>Manage Portfolio</h2>

      {/* Form to add/update a portfolio */}
      <form onSubmit={handleSubmit}>
        {/* Category dropdown */}
        <div className="admin-portfolio-form-group">
          <label htmlFor="category" className="admin-portfolio-form-label">Category</label>
          <select
            id="category"
            className="admin-portfolio-form-select"
            value={category}
            onChange={(e) => handleDropdownChange(e, setCategory)}
            required
          >
            <option value="">Select Category</option>
            <option value="LAB">LAB</option>
            <option value="TRAINING">TRAINING</option>
            <option value="FACULTY">FACULTY</option>
            <option value="ACHIEVEMENTS">ACHIEVEMENTS</option>
            <option value="STUDENTS">STUDENTS</option>
          </select>
        </div>

        {/* Image upload */}
        <div className="admin-portfolio-form-group">
          <label htmlFor="imageUrl" className="admin-portfolio-form-label">Upload Image</label>
          <input
            type="file"
            className="admin-portfolio-form-control"
            id="imageUrl"
            onChange={handleFileChange}
          />
        </div>

        <button type="submit" className="admin-portfolio-btn-primary">
          {editId ? 'Update' : 'Add'} Portfolio
        </button>
      </form>

      {/* List of portfolios */}
      <h3 className="admin-portfolio-heading">Existing Portfolios</h3>
      <div className="admin-portfolio-table-wrapper">
      <table className="admin-portfolio-table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Image</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {portfolios.map((portfolio) => (
            <tr key={portfolio._id}>
              <td>{portfolio.category}</td>
              <td>
                {portfolio.imageUrl && (
                  <img src={portfolio.imageUrl} alt="Portfolio" width="100" />
                )}
              </td>
              <td>
                <button
                  className="admin-portfolio-btn-info me-2"
                  onClick={() => handleEdit(portfolio)}
                >
                  Edit
                </button>
                <button
                  className="admin-portfolio-btn-danger"
                  onClick={() => handleDelete(portfolio._id)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      </div>
    </div>
  );
};

export default Portfolio;
